﻿import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/catch';

// APP 
import { SiteContact } from '../../viewmodel'
import { EntityAdded } from '../../viewmodel'
import { SiteEntityParam } from '../../viewmodel';
import { LookupService } from '../../services/lookup.service';
import { EntityService } from '../../services/entity.service';
import { BuildingService } from '../../services/building.service';
import { SharedService } from '../../services/shared.service';
import { HelperService } from '../../services/helper.service';

@Component({
    selector: 'app-addcontacts',
    templateUrl: './addsitecontacts.component.html',
    providers: [EntityService, BuildingService]
})
export class AddSiteContactsComponent implements OnInit {
    title: string = 'Add Contacts';
    Instruction: string = 'A site contact is any person that can be reached on behalf of the company below. <span class="bold">Your application must include at least one contact for each company added.</span> You can add as many contacts as you wish to your site entities.'; 

    contactForm: FormGroup;
    public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    public extensionMask = [/\d/, /\d/, /\d/, /\d/]
    public noSpaceAtBeginning = /^[^-\s]/; 

    pageError: any = [];
    pageSuccess: any = [];
    submitted: boolean = false;
    error: string;
    projectId: number = 0;
    siteEntityId: number = 0;
    siteProjectBuildingId: number = 0; 
    PartyRoleSeqNo: any;
    PartyRoleName: string;
    PartyId: any;
    PartyStagingId: any;
    selectedcompanyDdl = 0;
    type: string;
    contact: any;
    devTeamContact: any;
    contacts: Array<any>;
    companies: Array<any>;
    hasCompany: boolean = false;
    companyName: string;
    siteAddress: string = ''; 
    entityAdded: any;
    newEntityEntry: string = '';
    isDdlDisable: boolean = true;
    selectedCompanyIndexId: number = 0;
    isCheckPrimDisable: boolean = false;
    attrDisabled: any = null;   //'disabled'  or null for enable
    siteEntityParam: any; 

    constructor(private router: Router
        , private frmBuilder: FormBuilder
        , private activeRoute: ActivatedRoute
        , private lookupService: LookupService
        , private entityService: EntityService
        , private buildingService: BuildingService
        , private sharedService: SharedService
        , private helperService: HelperService) {

        this.contact = new SiteContact();
        this.entityAdded = new EntityAdded();
        this.contact.primaryContact = false;
        this.siteEntityParam = new SiteEntityParam(); 
    }

    ngOnInit() {
        this.title = "Add Contact";

        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null) {
                this.contact.projectId = this.projectId = ids.projectId;
            }
        }
        if (this.projectId <= 0)
            this.sharedService.navigateHome();

            if (this.sharedService.getData('SiteEntityParam') != null) {
                let param = JSON.parse(this.sharedService.getData('SiteEntityParam'));
                let sep = param.sep; 
                this.siteEntityParam = param.sep as SiteEntityParam; 

                this.contact.ProjectBuildingID = param.sep.siteProjectBuildingId;  // param.sep.ProjectBuildingID;  siteProjectBuildingId
                //this.contact.ProjectBldgDevTeamID = this.siteEntityId = param.sep.ProjectBldgDevTeamID =11;
                this.contact.ProjectBldgDevTeamID = this.siteEntityId = param.sep.projectBldgDevTeamId;
                this.contact.BuildingID = param.sep.bldgId;   //param.sep.BuildingID
                if (sep.contactId != null)
                    this.contact.commContactId = sep.contactId;

                if (sep.newEntityEntry != null)

                    this.newEntityEntry = sep.newEntityEntry;
                if (this.newEntityEntry == 'Y') {
                    this.attrDisabled = 'disabled';
                    this.contact.primaryContact = true;
                }
                if (sep.partyId != 0) {
                    this.PartyId = sep.partyId;
                    this.entityAdded.PartySeqNo = sep.partyId;
                    this.entityAdded.IsStageEntry = false;
                }
                if (sep.partyStagingId != 0) {
                    this.PartyStagingId = sep.partyStagingId;
                    this.entityAdded.PartySeqNo = sep.partyStagingId;
                    this.entityAdded.IsStageEntry = true;
                }
                this.entityAdded.MIHProjectBldgDevTeamID = sep.projectBldgDevTeamId;

                this.PartyRoleName = sep.partyRoleName;    //sep.PartyRoleName;
                if (sep.partyRoleSeqNo != null) {
                    this.PartyRoleSeqNo = sep.partyRoleSeqNo;                    
                    if (this.PartyRoleName == null)
                        this.PartyRoleName = this.helperService.getSiteRoleName(sep.partyRoleSeqNo); 
                }  

                this.siteProjectBuildingId = sep.siteProjectBuildingId; 
                this.siteAddress = sep.siteAddress;
                if (sep.companyName != null)
                    this.companyName = sep.companyName;                
        }
        else {
            this.sharedService.navigateSummary();
        }  

        this.getSiteEntityContacts(this.entityAdded);
        if (this.siteProjectBuildingId > 0)
            this.getBuildingInfoOnlyByProjectBuildingId(this.siteProjectBuildingId);  

        this.contactForm = this.frmBuilder.group({

            fName: [null, [Validators.required, Validators.pattern(this.noSpaceAtBeginning), Validators.maxLength(30)]],
            lName: [null, [Validators.required, Validators.pattern(this.noSpaceAtBeginning), Validators.maxLength(30)]],
            primary: [],
            email: [null, [Validators.required, Validators.maxLength(100), Validators.email]],
            companyPhone: [null, [Validators.required, Validators.pattern(/^\([1-9]\d{2}\)\s\d{3}-\d{4}|[1-9]\d{9}$/)]],
            phoneExt: [],
            companyDdl: [-1]

        });
    }

     selectContact(index) {
        if (index >= 0) {
            this.contact.commContactId = this.contacts[index].CommContactID;
            this.contact.fName = this.contacts[index].FirstName;
            this.contact.lName = this.contacts[index].LastName;
            this.contact.email = this.contacts[index].EmailAddress;
            if (this.contacts[index].ContactPhone != null && this.contacts[index].ContactPhone[0] != null) {
                this.contact.companyPhone = this.contacts[index].ContactPhone[0].PhoneNumber;
                this.contact.phoneExt = this.contacts[index].ContactPhone[0].PhoneExtension;
            }
            else {
                this.contact.companyPhone = ''; 
                this.contact.phoneExt = '';
            }
        }
        else {
            this.contact.commContactId = 0;
            this.contact.fName = '';
            this.contact.lName = '';
            this.contact.email = '';
            this.contact.companyPhone = '';
            this.contact.phoneExt = '';

        }
    }

     getSiteEntityContacts(entityAdded) {

        this.entityService.getSiteEntityContacts(entityAdded)       
            .subscribe(
            successResp => {
              
                if (!successResp.Success)
                    this.showError(successResp.StatusMessage);
                else if (successResp.Result != null) {
                    if (successResp.Result.ContactDetails != null && successResp.Result.ContactDetails.length > 0) {
                        this.contacts = successResp.Result.ContactDetails;
                        this.contact.partyid = successResp.Result.PartySeqNo;  // assign party id & isStageEntry
                        this.contact.isStageEntry = successResp.Result.isStageEntry;

                    }
                    else {
                        this.contacts = [];
                    }
                }
            },
            error => {
                this.showError(error.ExceptionMessage)
            })
    }

    saveContact(btnType): any {
        this.submitted = true;
        let cont = this.contactForm.getRawValue();
        if (!this.contactForm.valid)
            return;

        if (this.contact.fName != null && this.contact.fName.trim() == '')
            this.contact.fName = '';
        if (this.contact.lName != null && this.contact.lName.trim() == '')
            this.contact.lName = '';
        if (this.contact.fName == '' || this.contact.lName == '')
            return;

        this.contact.fName = this.contact.fName.trim();
        this.contact.lName = this.contact.lName.trim();
        this.contact.projectId = this.projectId;
        this.contact.dbApplicationId = 84;

        this.contact.isStageEntry = this.entityAdded.IsStageEntry;
        this.contact.partyId = this.entityAdded.PartySeqNo;
        
        if (this.contact.phoneExt != null && this.contact.phoneExt != '') {
            this.contact.phoneExt = this.contact.phoneExt.replace(/_+/g, '');
        }

        // Remove masking
        if (this.contact.companyPhone) {
            this.contact.companyPhone = this.contact.companyPhone.replace(/\D/g, '');
        }

        //this.entityService.saveSiteEntityContact(this.contact)
        this.entityService.SaveNewSiteEntityContact(this.contact, this.siteEntityParam)
            .subscribe(
            success => {
                if (!success.Success) {
                    if (success.StatusMessage != null && success.StatusMessage.indexOf('Contact already exists') !== -1) {
                        this.showErrorAlert(success.StatusMessage);
                    }
                    else if (success.StatusMessage != null && success.StatusMessage.indexOf('entity has already been added') !== -1) {
                        this.showErrorAlert(success.StatusMessage);
                    }
                    else {
                        this.showError(success.StatusMessage);
                    }
                }
                else {
                    this.showSuccess('Site contact successfully added.')
                    if (btnType == 'NEXT') {
                        var result = success.Result;
                        this.sharedService.navigateSummary();
                    }
                    
                }
            },
            error => {
                this.showError(error.ExceptionMessage);
            })
    }

    //site address
    getBuildingInfoOnlyByProjectBuildingId(siteProjectBuildingId) {
        this.buildingService.GetBuildingInfoOnlyByProjectBuildingId(siteProjectBuildingId)
            .subscribe(
            successResp => {
                if (!successResp.Success) {
                    //this.pageError.push(successResp.StatusMessage);
                }
                else if (successResp.Result != null) {
                    if (successResp.Result.length > 0) {
                        var bldg = successResp.Result[0]; 
                        this.siteAddress = '- ' + bldg.HouseNumber + ' ' + bldg.StreetName;
                    }
                }
            },
            error => {
                window.scrollTo(0, 0);
            })
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    showErrorAlert(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(msg);
        this.sharedService.processError(msg);
    }

    showSuccess(msg) {
        this.pageSuccess = []; this.pageError = [];
        this.pageSuccess.push(msg);
        this.sharedService.scroll();
    }

    home() {
        this.sharedService.navigateHome();
    }

    back() {
        this.sharedService.navigateSummary();
    }

    resetForm() {
        this.entityAdded = new EntityAdded();
        this.contact = new SiteContact(); 
        this.contact.projectId = this.projectId;
        this.contact.entityId = this.siteEntityId;
        this.contact.dbApplicationId = 84;
        //this.selectCompany(0);
        this.selectedcompanyDdl = 0;
        this.submitted = false;
        this.isDdlDisable = false;
    }

    previous(btnType) {
        this.router.navigate(['/createentity']);
    }

    formatContact(contact) {
        var ret = '';

        if (!(contact.FirstName == null || contact.FirstName == ''))
            ret += contact.FirstName + ' ';
        if (!(contact.LastName == null || contact.LastName == ''))
            ret += contact.LastName;

        if (!(contact.EmailAddress == null || contact.EmailAddress == ''))
            ret += " Email: " + contact.EmailAddress;

        if (contact.ContactPhone != null && contact.ContactPhone.length > 0) {
            var comm = contact.ContactPhone[0];
            if (!(comm.PhoneNumber == null || comm.PhoneNumber == ''))
                ret += " Ph: " + this.formatPhone(comm.PhoneNumber);

            if (!(comm.PhoneExtension == null || comm.PhoneExtension == ''))
                ret += " Ext: " + comm.PhoneExtension;
        }
        return ret;
    }

    formatPhone(value) {
        if (value == null || value.length == 0)
            return "";

        let newPhone = '';
        switch (value.length) {
            case 10:
            case 9:
            case 8:
            case 7:
                newPhone = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);
                break;
            case 6:
            case 5:
            case 4:
                newPhone = value.slice(0, 3) + '-' + value.slice(3, 6);
                break;
            default:
                newPhone = value;
                break;
        }
        return newPhone;
    }
}
